export const homeHeader = {
  title: {
    part1: 'Hay ',
    part2: ' trabajos esperándote en ',
  },
  marketingLink: 'Conoce más',
  searchBar: 'Empleá tu pasión',
}
